import React from "react";
import ResponsiveAppBar from "./AppBar";
import Footer from "./Footer";
import { Container } from "@mui/material";
import { Outlet } from "react-router-dom";

export function LayoutLogin() {
  return (
    <>
      <ResponsiveAppBar />
      <main>
          <Outlet/>
      </main>
      <footer>
        <Footer />
      </footer>
    </>
  );
}
